import { render, staticRenderFns } from "./ObjDetailDisplayEdit.vue?vue&type=template&id=5f248056"
import script from "./ObjDetailDisplayEdit.vue?vue&type=script&lang=js"
export * from "./ObjDetailDisplayEdit.vue?vue&type=script&lang=js"
import style0 from "./ObjDetailDisplayEdit.vue?vue&type=style&index=0&id=5f248056&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports